<template>
  <v-form ref="form" flat class="pt-5">
    <v-row>
      <v-col cols="12">
        <DateIOSPicker
          label="Ngày"
          :date.sync="time"
          outlined
          class="required"
          :rules="[$rules.required, $rules.date, $rules.dateFromNow]"
          dense
        />
      </v-col>

      <v-col cols="12" class="py-1" v-for="(target, index) in targets" :key="target.id">
        <v-divider v-if="index > 0" class="mb-4"></v-divider>
        <div class="mb-2">
          <div class="d-flex align-start">
            <div class="flex-grow-1">
              <GradeClassStudentSelect
                ref="gradeClassSelects"
                :gradeCol="{ cols: 12, md: 6 }"
                :classCol="{ cols: 12, md: 6 }"
                :studentCol="{ cols: 12 }"
                :gradeRules="[$rules.required]"
                :classRules="[$rules.required]"
                :studentRules="[$rules.required]"
                @changed="data => gradeClassStudentChange(data, index)"
              />
              <v-row class="mt-1">
                <v-col cols="12">
                  <AutocompleteSubject
                    v-model="target.subject"
                    return-object
                    label="Tiết học"
                    hide-details="auto"
                    outlined
                    dense
                    clearable
                    class="required"
                    :rules="[$rules.required]"
                    :filter="{ grade: target.grade && target.grade.id ? target.grade.id : '' }"
                    :disabled="!target.grade || !target.grade.id || !target.class || !target.class.id"
                  />
                </v-col>
              </v-row>
            </div>
            <v-btn
              icon
              color="error"
              class="ml-2"
              style="margin-top: 2px"
              v-if="targets.length > 1"
              @click="removeTarget(index)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>

      <v-col cols="12" class="pt-0 text-right">
        <a href="#" @click.prevent="addTarget" class="text-decoration-underline primary--text">
          + Thêm học sinh khác
        </a>
      </v-col>

      <v-col cols="12">
        <RadioViolation :violation.sync="type" @change="type = $event" mandatory />
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="description"
          label="Nội dung"
          class="required"
          :rules="[$rules.required]"
          hide-details="auto"
          outlined
          dense
        ></v-textarea>
      </v-col>
      <v-col cols="12" class="pt-1 pb-0" v-if="currentSuggestions.length">
        <span class="text-caption grey--text mr-2">Gợi ý nhanh:</span>
        <v-chip
          v-for="suggestion in currentSuggestions"
          :key="suggestion.label"
          small
          outlined
          class="mr-2 mb-2"
          @click="addSuggestion(suggestion.text)"
        >
          {{ suggestion.label }}
        </v-chip>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapState } from 'vuex'
import { get } from 'lodash'
import moment from 'moment'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import AutocompleteSubject from '@/components/basic/input/AutocompleteSubject.vue'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import RadioViolation from './RadioViolation.vue'

export default {
  components: {
    GradeClassStudentSelect,
    AutocompleteSubject,
    DateIOSPicker,
    RadioViolation
  },
  data: () => ({
    targets: [{ id: Date.now(), subject: null }],
    description: '',
    type: '',
    time: moment().toISOString()
  }),
  computed: {
    ...mapState('app', ['currentSemester']),
    currentSuggestions() {
      if (this.type === 'commendation') {
        return [
          { label: 'Hăng hái phát biểu', text: 'hăng hái phát biểu trong giờ' },
          { label: 'Hoàn thành bài nhanh', text: 'hoàn thành bài nhanh' },
          { label: 'Lao động tốt', text: 'có ý thức lao động tốt' }
        ]
      } else if (this.type === 'violation') {
        return [
          { label: 'Đi học muộn', text: 'đi học muộn' },
          { label: 'Mất tập trung', text: 'mất tập trung trong giờ học' },
          { label: 'Ý thức kém', text: 'có ý thức kém' }
        ]
      }
      return []
    },
    isValidForm() {
      const targetsValid = this.targets.every(
        t => t.grade && t.grade.id && t.class && t.class.id && t.student && t.student.id && t.subject && t.subject.id
      )
      const descValid = !!(this.description && this.description.trim())
      return targetsValid && descValid && !!this.time
    }
  },
  watch: {
    isValidForm: {
      handler(val) {
        this.$emit('update:valid', val)
      },
      immediate: true
    }
  },
  methods: {
    addSuggestion(text) {
      if (!this.description) {
        this.description = 'Em ' + text + '.'
      } else {
        let currentDesc = this.description.trim()

        if (currentDesc.endsWith('.')) {
          currentDesc = currentDesc.slice(0, -1)
        }
        if (currentDesc.endsWith(',')) {
          currentDesc = currentDesc.slice(0, -1)
        }

        if (!currentDesc.toLowerCase().startsWith('em ')) {
          currentDesc = 'Em ' + currentDesc.charAt(0).toLowerCase() + currentDesc.slice(1)
        }

        this.description = currentDesc + ', ' + text + '.'
      }
    },
    gradeClassStudentChange(data, index) {
      this.$set(this.targets, index, { ...this.targets[index], ...data })
    },
    addTarget() {
      this.targets.push({ id: Date.now(), subject: null })
    },
    removeTarget(index) {
      this.targets.splice(index, 1)
    },
    reset() {
      this.targets = [{ id: Date.now(), subject: null }]
      this.description = null
      this.time = moment().toISOString()
      this.type = 'commendation'

      this.$refs.form.resetValidation()
    },
    validate() {
      const parentValid = this.$refs.form.validate()
      let childrenValid = true
      if (this.$refs.gradeClassSelects) {
        for (const select of this.$refs.gradeClassSelects) {
          if (select.validate && !select.validate()) {
            childrenValid = false
          }
        }
      }
      return parentValid && childrenValid
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      if (this.validate()) {
        const validTargets = this.targets.filter(t => t.student && t.student.id)
        if (validTargets.length === 0) return null

        return validTargets.map(target => ({
          grade: get(target, 'grade.id', ''),
          classData: get(target, 'class.id', ''),
          student: get(target, 'student.id', ''),
          subject: target.subject ? get(target.subject, 'id', '') : null,
          description: this.description,
          type: this.type,
          date: this.time,
          semester: this.currentSemester.id
        }))
      }
      return null
    },
    resetDefault() {
      if (this.violation) {
        this.targets = [
          {
            id: Date.now(),
            grade: this.violation.grade,
            class: this.violation.classData,
            student: this.violation.student,
            subject: this.violation.subject
          }
        ]
        this.description = this.violation.description
        this.type = this.violation.type
      } else {
        this.reset()
      }
    }
  }
}
</script>
